import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { LoggerService } from "@bfx/logger";
import { CALLOUT_SIZE, CALLOUT_TYPE } from "app/bfx-element-library/models/CalloutModel";
const logger = LoggerService.for(__dirname);

export const CALLOUT_VISIBLE = "callout-visible";
export const CALLOUT_HIDDEN = "callout-hidden";

@Component({
  selector: "bfx-callout",
  template: `
    <div [class]="displayClass">
      <div
        [class]="calloutContainerClass"
        [bfxTooltip]="tooltip"
        tooltipPosition="top"
        tooltipStyleClass="order-entry__panel-form-notifications__tooltip"
      >
        <i [class]="calloutIconClass"></i>
        <span class="callout-message">{{ message }}</span>
        <bfx-icon-button
          *ngIf="showClear"
          size="sm"
          iconClass="icon-close"
          (action)="clear()"
          title="Clear"
        ></bfx-icon-button>
      </div>
    </div>
  `,
  standalone: false,
})
export class BfxCalloutComponent implements OnChanges {
  @Input() calloutType: CALLOUT_TYPE = "info";
  @Input() calloutSize: CALLOUT_SIZE = "sm";

  @Input() displayTime: number = 0;

  public calloutContainerClass: string;
  public calloutIconClass: string;
  public displayClass: string;

  @Input() public message: string;
  @Input() public tooltip: string;
  @Input() public showClear: boolean = false;

  @Output() onCalloutHide: EventEmitter<void> = new EventEmitter();

  private timeoutId: any;

  constructor(
    private element: ElementRef,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      switch (propName) {
        case "message":
          // this.scheduleShowAndHide();
          // Update visibility of callout based on message
          const newClass = this.message?.length > 0 ? CALLOUT_VISIBLE : CALLOUT_HIDDEN;
          if (newClass !== this.displayClass) {
            this.displayClass = newClass;
            if (newClass == CALLOUT_HIDDEN) {
              this.onCalloutHide.next();
            }
          }
          break;
      }
      this.updateClasses();
    }
  }

  public clear() {
    this.displayClass = CALLOUT_HIDDEN;
    this.onCalloutHide.next();
  }

  private updateClasses(): void {
    if (!this.calloutType) {
      this.calloutType = "info";
    }
    if (!this.calloutSize) {
      this.calloutSize = "sm";
    }
    this.calloutContainerClass = `bfx-callout-${this.calloutType}-${this.calloutSize}`;
    switch (this.calloutType) {
      case "neutral":
        this.calloutIconClass = "icon_ion_info_filled";
        break;
      case "info":
        this.calloutIconClass = "icon_ion_info_filled";
        break;
      case "negative":
        this.calloutIconClass = "icon_ion_error_filled";
        break;
      case "positive":
        this.calloutIconClass = "icon_ion_check_circle_filled";
        break;
      case "warning":
        this.calloutIconClass = "icon_ion_warning_filled";
        break;
    }
  }

  private scheduleShowAndHide() {
    // Always clear any pending transition
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = 0;
    }

    const element = this.element.nativeElement?.firstElementChild as Element;
    element["style"].height = null;

    if (this.message) {
      // First we make sure message is visible
      this.displayClass = CALLOUT_VISIBLE;

      if (this.displayTime > 0) {
        // Can only animate height if height is explicitly specified - so first we wait until the specified display time
        // then calculate the actual height.
        // We then set the height explicitly as a style and 100ms later set the height to 0 which will animate the
        // height from full height to 0
        this.timeoutId = setTimeout(() => {
          // After first timer, explicitly set the height
          const rect = element.getBoundingClientRect();
          element["style"].height = rect.height + "px";
          this.timeoutId = setTimeout(() => {
            // Immediately after, set height to 0 which should animate
            element["style"].height = "0px";
            this.displayClass = "callout-hiding";
            this.timeoutId = setTimeout(() => {
              // After animate duration change the style to hidden
              element["style"].height = null;
              this.displayClass = CALLOUT_HIDDEN;
              this.timeoutId = 0;
              // Dispatch clear event at this stage as it should be considered to be hidden
              this.onCalloutHide.next();
              this.cd.markForCheck();
            }, 1000);
            this.cd.markForCheck();
          }, 100);
        }, this.displayTime);
      }
    } else {
      this.displayClass = CALLOUT_HIDDEN;
      this.message = null;
      this.onCalloutHide.next();
    }
    this.cd.markForCheck();
  }
}
